module.exports = __webpack_public_path__ + "static/img/8.1760794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/8.png
// module id = o5ll
// module chunks = 0